module.exports = __webpack_public_path__ + "static/media/overview.fc013257.svg";